/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Nov 02 2023
 **/

import { css, Theme } from "@emotion/react";
import styled from "@emotion/styled";

import { Row, Column, Menu } from "@/frameworks/designStuff/components";

export const shortDirectMessageContentCss = (theme: Theme) => css`
	color: ${theme.colors.neutral_50_100};
`;

export const ShortDirectMessageIconWrap = styled(Row)`
	position: absolute;
	right: 4px;
	width: 32px;
	height: 32px;
`;

export const ShortDirectMessageList = styled(Column.ul)`
	li {
		width: 100%;
	}

	li:last-child {
		margin-bottom: 12px;
	}
`;

export const SubMenu = styled(Menu)`
	position: absolute;
	top: 42px;
	left: 50%;
	transform: translateX(-50%);
	width: 288px;
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
	z-index: 1;
`;

export const userListItemCss = css`
	margin: 0px 0px 0 16px;
	padding: 6px 16px 6px 4px;
	&:hover {
		border-radius: 12px;
		padding: 0 6px 0 4px;
		.more-icon {
			display: flex;
		}
		.notify-icons {
			display: none;
		}
	}
	.more-icon {
		display: none;
	}
`;
